import { api } from ".."

// função para pesquisar cidades
const CitiesService = async (city: string, state: number, page: number) => {

    const response = await api.get('cities', {
        params: {
            city, state, page
        }
    });

    return response;

}
// função para pesquisar cidades

// função para cadastrar cidade
const CityCreateService = async (description: string, state: number) => {

    const response = await api.post('cities', {
        description, state
    });

    return response;

}
// função para cadastrar cidade

// função para desativar/ativar cidade
const CityDeleteService = async (id: number) => {

    const response = await api.delete(`cities/${id}`);

    return response;

}
// função para desativar/ativar cidade

export {
    CitiesService,
    CityCreateService,
    CityDeleteService    
}